import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/comics';

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "韩国漫画网",
    "url": "https://www.koreanmanhwa.cn/",
    "description": "韩国漫画网收录好看的韩国漫画，支持韩漫在线免费阅读和无遮韩漫大全",
    "inLanguage": "zh-CN",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.koreanmanhwa.cn/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "韩国漫画网",
    "url": "https://www.koreanmanhwa.cn/",
    "description": "韩国漫画网 - 好看的韩国漫画在线免费阅读平台"
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <HeroSection />
      <HotComics />
      <CategoryNav />
      <LatestUpdates />
      <FAQSection faqs={faqs} />
    </>
  );
}